// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"4fcc9fe3","4450":"4fcc9fe3","6679":"7d83dbf0","7185":"4fcc9fe3","9024":"4fcc9fe3"}[chunkId] + ".chunk.css";
};